export default {
  account_id_required: "ID tài khoản là bắt buộc.",
  account_not_exists: "Mật khẩu không hợp lệ.",
  accountIdRequired: "Phiên hết hạn! Hãy đăng nhập lại để tiếp tục ...",
  agent_comm_rate_required: "Tỷ lệ hoa hồng đại lý là bắt buộc.",
  agent_id_required: "ID đại lý là bắt buộc.",
  alphaNumOnly: "Chỉ sử dụng chữ và số",
  atLeastThreeMatchToBetParlay: "Ít nhất phải kết hợp ba trận đấu để đặt cược theo cược xiên.",
  atLeastTwoMatchToBetParlay: "Phải có ít nhất 2 trận đấu để được cược xiên với nhau.",
  bet_amount_required: "Yêu cầu số tiền đặt cược.",
  bet_id_required: "ID đặt cược là bắt buộc.",
  betAmountRequired: "Yêu cầu số tiền cược.",
  betExists: "Cược đã tồn tại.",
  betLowerMin: "Phần thầu của bạn ít hơn mức phần thầu tối thiểu.",
  betNotExists: "Vui lòng đặt cược hợp lệ để tham gia giải đấu.",
  betOverMax: "Phần thầu của bạn đã vượt mức phần thầu tối đa.",
  betOverMaxBet: "Phần thầu của bạn đã vượt mức phần thầu tối đa.",
  betOverMaxPerMatch: "Phần thầu của bạn đã vượt mức phần thầu tối đa.",
  betTypeRequired: "Yêu cầu loại cược.",
  BLOCK: "Tài khoản đã bị khoá !",
  changeStakeMax: "Số tiền đặt cược đầu vào đã bị thay đổi do giới hạn MAX.",
  changeStakeMin: "Số tiền đặt cược đầu vào đã bị thay đổi do giới hạn MIN.",
  CLOSE: "Tài khoản đã bị đóng !",
  close: "Tài khoản đã bị đóng ! Vui lòng liên hệ cấp trên của bạn để được tiếp tục...",
  confirmNewPasswordRequired: "Xác nhận mật khẩu mới bắt buộc phải có!",
  connectionFailed: "Không thể liên kết hệ thống ví.",
  containAlphaNum: "{fname} phải có ít nhất một chữ cái và một số.",
  "createRoomFailed-1": "Tạo phòng thất bại 1.",
  "createRoomFailed-2": "Tạo phòng thất bại 2.",
  "createRoomFailed-3": "Tạo phòng thất bại 3.",
  credit_amount_required: "Số tiền tín dụng được yêu cầu.",
  currency_required: "Đơn vị tiền tệ được yêu cầu.",
  currencyNotSupported: "Đơn vị tiền tệ không được hỗ trợ",
  currPasswordRequired: "Mật khẩu hiện tại bắt buộc phải có!",
  dataError: "Lỗi dữ liệu",
  debit_amount_required: "Số tiền ghi nợ là bắt buộc.",
  duplicate_credit_record: "Hồ sơ tín dụng trùng lặp.",
  duplicate_debit_record: "Tỷ lệ đang cập nhật ...",
  endDateRequired: "Ngày kết thúc là bắt buộc phải có!",
  EsportsDisabled: "Trò chơi thể thao điện tử bị vô hiệu hóa",
  forbiddenAccess: "Truy cập Bị Cấm",
  FREEZE: "Tài khoản đã bị đóng băng!",
  freeze: "Tài khoản của bạn đã bị đóng băng ! Vui lòng liên hệ cấp trên của bạn để được tiếp tục...",
  game_maintenance: "Trò chơi đang bảo trì.",
  incompletedRequest: "Đã xảy ra sự cố...",
  insufficient_balance: "Số dư không đủ",
  invalid_password: "Mật khẩu không hợp lệ.",
  invalidBetAmount: "Số tiền cược không hợp lệ.",
  invalidBets: "Thị trường này không khả dụng, vui lòng thử thị trường khác.",
  invalidCurrency: "Tiền không hợp lệ đặt cược",
  invalidleague: "Giải đấu không hợp lệ.",
  invalidMarketType: "Loại thị trường không hợp lệ được cung cấp.",
  invalidMatch: "Trận đấu không hợp lệ.",
  invalidMember: "Thành viên không hợp lệ.",
  invalidOddsBall: "Tỷ lệ cược đang cập nhật...",
  invalidOperator: "Toán tử không hợp lệ.",
  invalidPassword: "Mật khẩu không hợp lệ",
  invalidRoom: "Phòng không hợp lệ.",
  invalidRoomLimit: "Giới hạn phòng không hợp lệ.",
  invalidRoomPassword: "Mã PIN không hợp lệ. Mã PIN phải có 6 chữ số.",
  invalidRoomRate: "Giá phòng không hợp lệ.",
  invalidRoomType: "Loại phòng không hợp lệ.",
  invalidRTSMatchOdds: "Tỷ lệ cược RTS Match không hợp lệ.",
  invalidSession: "Phiên hết hạn! Hãy đăng nhập lại để tiếp tục ...",
  IPJoinedBefore: "IP đã tham gia trước đó.",
  isAlpha: "{fname} chỉ chấp nhận bảng chữ cái.",
  isAlphaNum: "{fname} chỉ chấp nhận chữ cái và số.",
  isEmail: "{fname} chấp nhận địa chỉ email hợp lệ.",
  isIpAddress: "{fname} chỉ chấp nhận địa chỉ IPv4 chỉ có giá trị.",
  isMaxLength: "{fname} phải nhỏ hơn hoặc bằng {fvalue} ký tự.",
  isMaxValue: "{fname} phải nhỏ hơn hoặc bằng {fvalue}.",
  isMinLength: "{fname} phải có ít nhất {fvalue} ký tự.",
  isMinValue: "{fname} phải có tối thiểu {fvalue}.",
  isNumeric: "{fname} chỉ chấp nhận numerics.",
  isOutrightRequired: "Tên cược vô địch là bắt buộc phải có!",
  // vuelidate
  isRequired: "Vui lòng nhập một {fname}.",
  isSameAs: "{fname} phải được giống như {fname2}.",
  isUrl: "{fname} hỉ chấp nhận URL.",
  "joinFailed-1": "Tham gia phòng thất bại 1.",
  "joinFailed-2": "Không thể tham gia phòng 2.",
  leagueIdRequired: "Tên giải đấu là bắt buộc phải có!",
  liveCasinoDisabled: "Sòng bạc trực tiếp bị vô hiệu hóa",
  liveMatchNotAllowed: "Trận đấu trực tiếp không được phép.",
  //tournament
  login_id_not_exists: "Đăng nhập không hợp lệ, vui lòng thử đăng nhập lại.",
  loginFailed: "Đăng nhập không thành công, xin vui lòng thử lại sau...",
  loginLimit: "Bạn đã đăng nhập quá thường xuyên, hãy thử lại sau 1 phút ...",
  lotteryDisabled: "Xổ số bị vô hiệu hóa",
  marketTypeChanged: "Phiếu cược đã bị xóa do thay đổi loại thị trường.<br />Vui lòng chọn lại từ thị trường.",
  marketTypeRequired: "Loại thị trường là bắt buộc.",
  master_comm_rate_required: "Yêu cầu tỷ lệ hoa hồng chính.",
  master_id_required: "Cần có ID chính.",
  matchDateRequired: "Yêu cầu ngày khớp.",
  matchHide: "Thị trường này không khả dụng, vui lòng thử thị trường khác.",
  matchLowerMin: "Đã xảy ra lỗi so khớp tối thiểu thấp hơn.",
  matchNotActive: "Trận đấu này không khả dụng, vui lòng thử thị trường trận đấu khác.",
  matchNotAllowBet: "Thị trường này không khả dụng, vui lòng thử thị trường khác.",
  matchOverMax: "Xảy ra lỗi so khớp vượt quá tối đa.",
  matchRequired: "Yêu cầu khớp.",
  maxMatch: "Tối đa {max} trận được chọn.",
  maxParlayTicket: "Đạt tối đa các trận đấu trong 1 lần cược xiên!",
  maxRoomLimit: "Số lượng Người chơi phải bằng hoặc nhỏ hơn 30.",
  maxRoomRate: "Phí vào cửa phải bằng hoặc nhỏ hơn 1000.",
  member_id_required: "ID thành viên là bắt buộc.",
  member_wallet_not_exists: "Ví thành viên không tồn tại.",
  memberExists: "Thành viên đã tồn tại.",
  memberJoinedBefore: "Bạn đã tham gia trước đó, xin lưu ý rằng phòng miễn phí chung chỉ có thể tham gia một lần.",
  minBetAmount: "Đã xảy ra lỗi về số tiền đặt cược tối thiểu.",
  MiniGameDisabled: "Trò chơi nhỏ đã bị vô hiệu hóa",
  minMatch: "Đã chọn tối thiểu 3 trận đấu.",
  minRoomLimit: "Số lượng Người chơi phải bằng hoặc nhiều hơn 3.",
  minRoomRate: "Phí vào cửa phải bằng hoặc lớn hơn 10.",
  new_login_id_exists: "Biệt danh không hiệu lực . Vui lòng cài đặt biệt danh khách .",
  newPasswordRequired: "Mật khẩu mới bắt buộc phải có!",
  nickNameRequired: "Biệt danh là bắt buộc phải có!",
  noMatchSelected: "Vui lòng chọn ít nhất 1 trận đấu.",
  notSameAs: "{fname} và {fname2} không thể giống nhau.",
  NoUserAccessRight: "Quyền truy cập bị từ chối ! Vui lòng liên hệ cấp trên để được tiếp tục...",
  oddsDisplayInvalid: "Tỷ lệ hiển thị không hợp lệ.",
  oddsIsUpdating: "Tỷ lệ đang cập nhật ...",
  OK: "đồng ý",
  pageNumberRequired: "Số trang là bắt buộc phải có!",
  pageSizeRequired: "Kích thước trang là bắt buộc phải có!",
  passwordRequired: "Mật khẩu bị bắt buộc !",
  passwordsNotMatch: "Mật khẩu không giống nhau!",
  permission_denied: "Quyền bị từ chối.",
  pointsOverLimit: "Xảy ra lỗi vượt quá giới hạn điểm.",
  rate_required: "Tỷ lệ được yêu cầu.",
  rateLowerMin: "Đã xảy ra lỗi xếp hạng tối thiểu thấp hơn.",
  rateOverMax: "Xảy ra lỗi đánh giá trên giá trị tối đa.",
  requestFailed: "Kết nối của bạn không ổn định. Vui lòng kiểm tra kết nối của bạn và thử lại.",
  requestLimit: "Bạn gửi yêu cầu quá nhiều.",
  requestPending: "Yêu cầu đang chờ xử lý...",
  result_exists: "Kết quả đã tồn tại.",
  room_id_required: "Cần có ID phòng.",
  roomClosed: "Phòng đã đóng.",
  roomClosedNotAllowed: "Không cho phép đóng phòng.",
  roomEnded: "Phòng đã hết.",
  roomEndedOrCancelled: "Phòng đã kết thúc hoặc bị hủy.",
  roomExists: "Không cho phép tạo nhiều hơn 1 phòng riêng.",
  RoomExists: "Không cho phép tạo nhiều hơn 1 phòng riêng.",
  roomFull: "Phòng đã đầy.",
  roomIdRequired: "ID phòng là bắt buộc.",
  roomIsPublicFree: "Phòng công khai miễn phí.",
  roomLimitLowerMin: "Đã xảy ra lỗi tối thiểu giới hạn phòng thấp hơn.",
  roomLimitOverMax: "Đã xảy ra lỗi giới hạn phòng trên mức tối đa.",
  roomLimitRequired: "Yêu cầu giới hạn phòng.",
  roomNotExists: "Phòng không tồn tại.",
  roomOverMax: "Đã xảy ra lỗi vượt quá dung lượng phòng tối đa.",
  roomPasswordRequired: "Mã PIN được yêu cầu.",
  roomRateRequired: "Yêu cầu giá phòng.",
  roomTypeRequired: "Loại phòng được yêu cầu.",
  s_senior_comm_rate_required: "Yêu cầu tỷ lệ hoa hồng cấp cao.",
  s_senior_id_required: "Cần có ID cấp cao.",
  secondary_account_exists: "Biệt danh của bạn đã được khởi tạo .",
  selectLeague: "Vui lòng chọn ít nhất 1 giải đấu",
  selectOption: "Vui lòng chọn {fname}",
  senior_comm_rate_required: "Tỷ lệ hoa hồng cấp cao là bắt buộc.",
  senior_id_required: "ID cao cấp là bắt buộc.",
  session_expired: "Phiên hết hạn! Hãy đăng nhập lại để tiếp tục ...",
  session_not_exists: "Phiên hết hạn! Hãy đăng nhập lại để tiếp tục ...",
  sessionTokenRequired: "Mã thông báo phiên là bắt buộc.",
  shareholder_comm_rate_required: "Tỷ lệ hoa hồng cổ đông là bắt buộc.",
  shareholder_id_required: "ID cổ đông là bắt buộc.",
  slotDisabled: "Máy xèng bị vô hiệu hóa",
  sportsTypeRequired: "Loại thể thao là bắt buộc phải có!",
  startDateRequired: "Ngày bắt đầu là bắt buộc phải có!",
  SUSPEND: "Tài khoản của bạn đã được thay đổi thành chỉ XEM.",
  suspend: "Tài khoản đã bị treo ! Vui lòng liên hệ cấp trên của bạn để được tiếp tục...",
  systemError: "Hệ thống nội bộ lỗi .",
  tournamentDisabled: "Giải đấu bị vô hiệu hóa, vui lòng kiểm tra liên hệ với tuyến trên của bạn.",
  tournamentLeagueExists: "Giải đấu có tồn tại.",
  tournamentMatchExists: "Trận đấu giải đấu tồn tại.",
  transfer_id_required: "ID chuyển khoản là bắt buộc.",
  unableToGetBalanceAtTheMoment: "Lỗi máy chủ nội bộ.",
  usernameRequired: "Tên đăng nhập bị bắt buộc !",
  workingDateRequired: "Ngày hoạt động là bắt buộc phải có!",
  matchNotStarted: "Trận đấu chưa bắt đầu.",
  cashOutUnavailable: "Rút tiền không khả dụng.",
  errorCashoutAmount: "Rút tiền đang được cập nhật...",
  invalidParameter: "Tham số không hợp lệ.",  
  startTimeRequired: "Thời gian bắt đầu là bắt buộc.",
  endTimeRequired: "Thời gian kết thúc là bắt buộc.",
  oddsTypeIDRequired: "Loại tỷ lệ cược là bắt buộc.",
  commissionRequired: "Phí cược là bắt buộc.",
  requestTimeRequired: "Thời gian yêu cầu là bắt buộc.",
  statusRequired: "Trạng thái là bắt buộc.",
  invalidStartTime: "Thời gian bắt đầu không hợp lệ.",
  invalidEndTime: "Thời gian kết thúc không hợp lệ.",
  invalidOddsTypeID: "Loại tỷ lệ cược không hợp lệ.",
  invalidCommission: "Phí cược không hợp lệ.",
  invalidRequestTime: "Thời gian yêu cầu không hợp lệ.",
  invalidStatus: "Trạng thái không hợp lệ.",
  invalidAlgoMatchInfo: "Thị trường này đã đóng, vui lòng thử thị trường khác.",
  invalidAlgoSliderLeagueInfo: "Thông tin giải đấu không hợp lệ.",
  invalidAlgoSliderMinutesWeight: "Trọng số phút không hợp lệ.",
  invalidAlgoSliderBetType: "Loại cược không hợp lệ.",
  invalidRTSRunningScoreDetails: "Chi tiết điểm số RTS không hợp lệ.",
  invalidProviderGoalTimeLine: "Thời gian đạt mục tiêu không hợp lệ.",
  invalidSliderTimeRange: "Khoảng thời gian không hợp lệ.",
  invalidMOMatchOdds: "Tỷ lệ cược trận đấu đang cập nhật...",
  invalidProviderSlider: "Thông tin TM không hợp lệ.",
  invalidCombineBetTypeAndOddsFormat: "Loại cược và tỷ lệ cược không hợp lệ.",
  invalidMatchInformation: "Thông tin trận đấu không hợp lệ.",
  marketClose: "Thị trường này đã đóng cửa, vui lòng thử các thị trường khác.",
  error: "Lỗi",
  freeRoomNeedBet: "Vui lòng đặt cược hợp lệ để truy cập phòng miễn phí.",
};
